import injectSheet from 'react-jss'
import AddButton from './CloseButton'
import styles from './CloseButton.styles'

export default injectSheet(styles)(AddButton)
